import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { LogOut, Package, FileText, ShieldCheck } from 'lucide-react';
import { AdminProducts } from './admin/AdminProducts';
import { AdminQuotations } from './admin/AdminQuotations';
import { Toaster } from './ui/sonner';

export const AdminDashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('products');

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Toaster position="top-center" richColors />

      {/* Header */}
      <header className="bg-gradient-to-r from-blue-900 via-blue-800 to-green-700 text-white shadow-lg">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="bg-white rounded-full p-2 shadow-lg">
                <ShieldCheck className="text-blue-900" size={28} />
              </div>
              <div>
                <h1 className="text-xl font-bold">DYC MARKETING SDN BHD Admin Panel</h1>
                <p className="text-blue-100 text-xs">Welcome, {user?.name || 'Admin'}</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <a
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                className="hidden sm:inline-block text-yellow-300 hover:text-yellow-100 text-sm font-medium"
              >
                View Website →
              </a>
              <Button
                onClick={handleLogout}
                variant="outline"
                size="sm"
                className="bg-white/10 border-white/30 text-white hover:bg-white hover:text-blue-900"
                data-testid="logout-btn"
              >
                <LogOut size={16} className="mr-2" />
                Logout
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="container mx-auto px-4 py-8">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full max-w-md grid-cols-2 mb-8 bg-white shadow-md p-1 h-auto">
            <TabsTrigger
              value="products"
              className="data-[state=active]:bg-blue-900 data-[state=active]:text-white py-3 text-base font-semibold"
              data-testid="tab-admin-products"
            >
              <Package className="mr-2" size={18} />
              Products
            </TabsTrigger>
            <TabsTrigger
              value="quotations"
              className="data-[state=active]:bg-blue-900 data-[state=active]:text-white py-3 text-base font-semibold"
              data-testid="tab-admin-quotations"
            >
              <FileText className="mr-2" size={18} />
              Quotations
            </TabsTrigger>
          </TabsList>

          <TabsContent value="products" className="mt-0">
            <AdminProducts />
          </TabsContent>

          <TabsContent value="quotations" className="mt-0">
            <AdminQuotations />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};
